/* ============================================================
   LUMEX LIGHT THEME — JavaScript
============================================================ */

// ---- NAV SCROLL ----
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 20);
  });
}

// ---- INTERSECTION OBSERVER (scroll animations) ----
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
    }
  });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

function initAnimations(root) {
  var scope = root || document;
  scope.querySelectorAll('[data-anim]').forEach(function(el) {
    // In Shopify customizer, show everything immediately
    if (window.Shopify && window.Shopify.designMode) {
      el.classList.add('is-visible');
    } else {
      observer.observe(el);
    }
  });
}

initAnimations();

// Re-init when Shopify customizer reloads a section
document.addEventListener('shopify:section:load', function(e) {
  initAnimations(e.target);
});
document.addEventListener('shopify:section:select', function(e) {
  initAnimations(e.target);
});

// ---- COUNTER ANIMATION ----
function animateCounter(el, target, duration) {
  duration = duration || 1800;
  var start = 0;
  var step = target / (duration / 16);
  function update() {
    start = Math.min(start + step, target);
    el.textContent = Math.floor(start);
    if (start < target) requestAnimationFrame(update);
    else el.textContent = target;
  }
  requestAnimationFrame(update);
}

var counters = document.querySelectorAll('.counter-num');
var countersStarted = false;
if (counters.length > 0) {
  var heroStats = document.querySelector('.hero-stats');
  if (heroStats) {
    var counterObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && !countersStarted) {
        countersStarted = true;
        counters.forEach(function(el, i) {
          setTimeout(function() {
            animateCounter(el, parseInt(el.dataset.target));
          }, i * 200);
        });
      }
    }, { threshold: 0.5 });
    counterObserver.observe(heroStats);
  }
}

// ---- RIPPLE on click ----
document.querySelectorAll('.btn-primary, .btn-buy').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    var circle = document.createElement('span');
    circle.style.cssText = [
      'position:absolute',
      'border-radius:50%',
      'background:rgba(255,255,255,0.3)',
      'width:100px',
      'height:100px',
      'left:' + (e.offsetX - 50) + 'px',
      'top:' + (e.offsetY - 50) + 'px',
      'animation:rippleClick 0.6s ease-out forwards',
      'pointer-events:none'
    ].join(';');
    this.style.position = 'relative';
    this.style.overflow = 'hidden';
    this.appendChild(circle);
    setTimeout(function() { circle.remove(); }, 700);
  });
});

// Ripple keyframes
var rippleStyle = document.createElement('style');
rippleStyle.textContent = '@keyframes rippleClick { from { transform:scale(0); opacity:0.5; } to { transform:scale(4); opacity:0; } }';
document.head.appendChild(rippleStyle);

// ---- FEATURE CARD HOVER GLOW ----
document.querySelectorAll('.feature-card').forEach(function(card) {
  card.addEventListener('mousemove', function(e) {
    var rect = card.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    card.style.background = 'radial-gradient(circle at ' + x + '% ' + y + '%, rgba(0,87,255,0.04), var(--gray-50) 60%)';
  });
  card.addEventListener('mouseleave', function() {
    card.style.background = '';
  });
});

// ---- SMOOTH SCROLL (for anchor links) ----
document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
  anchor.addEventListener('click', function(e) {
    var href = this.getAttribute('href');
    if (href === '#') return;
    var target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// ---- MOBILE NAV ----
var mobileBtn = document.querySelector('.nav-mobile-btn');
var navLinks = document.querySelector('.nav-links');
if (mobileBtn && navLinks) {
  mobileBtn.addEventListener('click', function() {
    var isOpen = navLinks.style.display === 'flex';
    navLinks.style.cssText = isOpen
      ? ''
      : 'display:flex;flex-direction:column;position:fixed;top:72px;left:0;right:0;background:rgba(255,255,255,0.97);backdrop-filter:blur(20px);padding:24px;border-bottom:1px solid #DDE2F0;gap:20px;z-index:99;';
  });
}
